module.exports = __webpack_public_path__ + "static/img/9.5d9fce3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/9.png
// module id = +5oW
// module chunks = 0